import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import {
  toggleShowFullForm,
} from '../Actions/QuickSearch.action';

const QSR = 'quick-search-result';
const QSR_ITEM = `${QSR}__item`;

const sameCategory = (item, index, array) =>
  (index > 0 && array[index - 1].category === array[index].category) || item.showAll;

const hasLinkDisabledClass = (url) => {
  return !url ? `${QSR}__link--disabled` : ``;
};

const itemLinkClassName = (showAll, url) =>
  `${QSR}${showAll ? '__show-all' : '__link ' + hasLinkDisabledClass(url)}`;

const selectedItemClassName = (selectedItem, index) => {
  return (selectedItem === index) ? `${QSR_ITEM}--selected` : ``;
};

const QuickSearchResult = ({ result, selectedItem, searchUrl }) => {
  const dispatch = useDispatch();
  return (
    <>
      <div className="quick-search-result__overlay" onClick={() => dispatch(toggleShowFullForm())}></div>
      <ul className={QSR}>
        {result &&
          result.map((item, index, array) => {
            const { category, showAll, url, hasImage, imageSource, name } = item;
            const imageVisible = hasImage && imageSource;

            return (
              <Fragment key={index}>
                {category !== 'NoHit' && !sameCategory(item, index, array) &&
                  <li className={`${QSR_ITEM} ${QSR}__group-header`}>{category}</li>
                }
                {name &&
                  <li
                    className={`${QSR_ITEM} ${selectedItemClassName(selectedItem, index)}`}
                  >
                    <a
                      className={itemLinkClassName(showAll, url)}
                      href={showAll ? searchUrl : url}
                    >
                      {imageVisible && (
                        <img className={`${QSR}__image`} src={imageSource} />
                      )}
                      <div>{name}</div>
                    </a>
                  </li>
                }
              </Fragment>
            );
          })}
      </ul>
    </>
  )
};

export default QuickSearchResult;
